<template>
  <div class="l-container">

    <p class="m-label">
      新規追加
      <span class="errors">
        <span v-if="!valid"> {{errors}} が入力されていません</span>
        <span v-if="valid"></span>
      </span>
    </p>

    <btn @click.native="reset">Reset</btn>

    <form class="h-adr" @submit.prevent="postTutor">
      <div class="form-wrapper">
        <tutor-form :tutor="tutor" :watch="watch"></tutor-form>
      </div>

      <button type="submit" class="u-btn"><i class="fa fa-user-plus"></i>先生情報を新規追加</button>
    </form>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      tutor: {
        state: 1,
        registration_date: moment().format('YYYY/MM/DD'),
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        gender: 0,
        birthday: '0001/01/01',
        zip: '',
        pref: 0,
        geometry: '',
        address1: '',
        address2: '',
        tel1: '',
        tel2: '',
        mail1: '',
        mail2: '',
        home_zip: '',
        home_pref: 0,
        home_address1: '',
        home_address2: '',
        home_tel: '',
        school_name: '',
        school_stage: 0,
        department: '',
        old_grade: 0,
        grade_flag: 0,
        department_type: 0,
        club: '',
        transportation_car: 0,
        transportation_bike: 0,
        transportation_scooters: 0,
        transportation_bicycle: 0,
        transportation_train: 0,
        transportation_none: 0,
        nearest_station: '',
        high_school_name: '',
        high_school_club: '',
        exam_s: 0,
        exam_c: 0,
        exam_k: 0,
        exam_d: 0,
        experience_tutor: 0,
        experience_tutor_note: '',
        experience_cram: 0,
        experience_cram_note: '',
        experience_none: 0,
        medium: 0,
        medium_note: '',
        published: 0,
        information: 1,
        impression: 0,
        training: 0,
        training_note: '',
        ssk: 0,
        note: ''
      },

      watch: {
        medium: '',

        pref: '',
        home_pref: '',
        school_stage: '',
        old_grade: '',
        transportation_car: '',
        transportation_bike: '',
        transportation_scooters: '',
        transportation_bicycle: '',
        transportation_train: '',
        transportation_none: '',
        exam_s: '',
        exam_c: '',
        exam_k: '',
        exam_d: '',
        experience_tutor: '',
        experience_cram: '',
        experience_none: '',
        training: '',
        ssk: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },

    // validation
    registration_dateErrors () {
      return this.tutor.registration_date ? [] : ['登録日']
    },

    f_name_kanaErrors () {
      return this.tutor.f_name_kana ? [] : ['せい']
    },

    l_name_kanaErrors () {
      return this.tutor.l_name_kana ? [] : ['めい']
    },

    birthdayErrors () {
      return this.tutor.birthday ? [] : ['生年月日']
    },

    prefErrors () {
      return this.tutor.pref ? [] : ['都道府県']
    },

    address1Errors () {
      return this.tutor.address1 ? [] : ['住所(市区町村・番地)']
    },

    tel1Errors () {
      return this.tutor.tel1 ? [] : ['携帯TEL']
    },

    school_stageErrors () {
      return this.tutor.school_stage ? [] : ['区分']
    },

    errors () {
      let errors = [].concat(
        this.registration_dateErrors,
        this.f_name_kanaErrors,
        this.l_name_kanaErrors,
        this.birthdayErrors,
        this.prefErrors,
        this.address1Errors,
        this.tel1Errors,
        this.school_stageErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid () {
      return !this.errors
    }
  },
  watch: {
    'watch.medium': function (now, old) {
      if (now) {
        this.tutor.medium = now.channel_id
      }
    },

    'watch.old_grade': function (now, old) {
      if (now) {
        this.tutor.old_grade = now.value
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.tutor.pref = now.id
        this.tutor.geometry = now.name
      }
    },

    'watch.home_pref': function (now, old) {
      if (now) {
        this.tutor.home_pref = now.id
      }
    },

    'watch.school_stage': function (now, old) {
      if (now) {
        this.tutor.school_stage = now.value
      }
    },

    'watch.transportation_car': function (now, old) {
      if (now === true) {
        this.tutor.transportation_car = 1
      } else if (now === false) {
        this.tutor.transportation_car = 0
      }
    },

    'watch.transportation_bike': function (now, old) {
      if (now === true) {
        this.tutor.transportation_bike = 1
      } else if (now === false) {
        this.tutor.transportation_bike = 0
      }
    },

    'watch.transportation_scooters': function (now, old) {
      if (now === true) {
        this.tutor.transportation_scooters = 1
      } else if (now === false) {
        this.tutor.transportation_scooters = 0
      }
    },

    'watch.transportation_bicycle': function (now, old) {
      if (now === true) {
        this.tutor.transportation_bicycle = 1
      } else if (now === false) {
        this.tutor.transportation_bicycle = 0
      }
    },

    'watch.transportation_train': function (now, old) {
      if (now === true) {
        this.tutor.transportation_train = 1
      } else if (now === false) {
        this.tutor.transportation_train = 0
      }
    },

    'watch.transportation_none': function (now, old) {
      if (now === true) {
        this.tutor.transportation_none = 1
      } else if (now === false) {
        this.tutor.transportation_none = 0
      }
    },

    'watch.exam_s': function (now, old) {
      if (now === true) {
        this.tutor.exam_s = 1
      } else if (now === false) {
        this.tutor.exam_s = 0
      }
    },

    'watch.exam_c': function (now, old) {
      if (now === true) {
        this.tutor.exam_c = 1
      } else if (now === false) {
        this.tutor.exam_c = 0
      }
    },

    'watch.exam_k': function (now, old) {
      if (now === true) {
        this.tutor.exam_k = 1
      } else if (now === false) {
        this.tutor.exam_k = 0
      }
    },

    'watch.exam_d': function (now, old) {
      if (now === true) {
        this.tutor.exam_d = 1
      } else if (now === false) {
        this.tutor.exam_d = 0
      }
    },

    'watch.experience_tutor': function (now, old) {
      if (now === true) {
        this.tutor.experience_tutor = 1
      } else if (now === false) {
        this.tutor.experience_tutor = 0
      }
    },

    'watch.experience_cram': function (now, old) {
      if (now === true) {
        this.tutor.experience_cram = 1
      } else if (now === false) {
        this.tutor.experience_cram = 0
      }
    },

    'watch.experience_none': function (now, old) {
      if (now === true) {
        this.tutor.experience_none = 1
      } else if (now === false) {
        this.tutor.experience_none = 0
      }
    },

    'watch.training': function (now, old) {
      if (now === true) {
        this.tutor.training = 1
      } else if (now === false) {
        this.tutor.training = 0
      }
    },

    'watch.ssk': function (now, old) {
      if (now === true) {
        this.tutor.ssk = 1
      } else if (now === false) {
        this.tutor.ssk = 0
      }
    }
  },
  methods: {
    calcAge (birthday) {
      var x = Date.parse(birthday) // 変換(ミリ秒が返される)
      var date = new Date(x) // ミリ秒をnew Dateに渡す
      var ageDifMs = Date.now() - date
      var ageDate = new Date(ageDifMs)
      return ageDate.getUTCFullYear() - 1970
    },

    postTutor () {
      if (this.tutor.pref !== 0 && this.tutor.medium !== 0) {
        this.$store.dispatch('postTutor', {
          this: this,
          tutor: this.tutor,
          watch: this.watch,
          reset: this.reset
        })
        this.save()
      } else {
        if (this.tutor.pref === 0) {
          alert('都道府県が選択されていません')
        } else if (this.tutor.medium === 0) {
          alert('媒体が選択されていません')
        }
      }
    },

    save () {
      // alert('save')
      let arr = []
      let obj = {

        state: this.tutor.state,
        registration_date: this.tutor.registration_date,
        f_name: this.tutor.f_name,
        l_name: this.tutor.l_name,
        f_name_kana: this.tutor.f_name_kana,
        l_name_kana: this.tutor.l_name_kana,
        gender: this.tutor.gender,
        birthday: this.tutor.birthday,
        zip: this.tutor.zip,
        pref: this.watch.pref,
        address1: this.tutor.address1,
        address2: this.tutor.address2,
        tel1: this.tutor.tel1,
        tel2: this.tutor.tel2,
        mail1: this.tutor.mail1,
        mail2: this.tutor.mail2,
        home_zip: this.tutor.home_zip,
        home_pref: this.watch.home_pref,
        home_address1: this.tutor.home_address1,
        home_address2: this.tutor.home_address2,
        home_tel: this.tutor.home_tel,
        school_name: this.tutor.school_name,
        school_stage: this.watch.school_stage,
        department: this.tutor.department,
        old_grade: this.watch.old_grade,
        grade_flag: this.tutor.grade_flag,
        department_type: this.tutor.department_type,
        club: this.tutor.club,
        transportation_car: this.watch.transportation_car,
        transportation_bike: this.watch.transportation_bike,
        transportation_scooters: this.watch.transportation_scooters,
        transportation_bicycle: this.watch.transportation_bicycle,
        transportation_train: this.watch.transportation_train,
        transportation_none: this.watch.transportation_none,
        nearest_station: this.tutor.nearest_station,
        high_school_name: this.tutor.high_school_name,
        high_school_club: this.tutor.high_school_club,
        exam_s: this.watch.exam_s,
        exam_c: this.watch.exam_c,
        exam_k: this.watch.exam_k,
        exam_d: this.watch.exam_d,
        experience_tutor: this.watch.experience_tutor,
        experience_tutor_note: this.tutor.experience_tutor_note,
        experience_cram: this.watch.experience_cram,
        experience_cram_note: this.tutor.experience_cram_note,
        experience_none: this.watch.experience_none,
        medium: this.watch.medium,
        medium_note: this.tutor.medium_note,
        published: this.tutor.published,
        information: this.tutor.information,
        impression: this.tutor.impression,
        training: this.watch.training,
        training_note: this.tutor.training_note,
        ssk: this.watch.ssk,
        note: this.tutor.note
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('TutorsAdd', setjson)
    },

    get () {
      // alert('get')
      let getjson = localStorage.getItem('TutorsAdd')
      let obj = JSON.parse(getjson)

      this.tutor.state = obj['state']
      this.tutor.registration_date = obj['registration_date']
      this.tutor.f_name = obj['f_name']
      this.tutor.l_name = obj['l_name']
      this.tutor.f_name_kana = obj['f_name_kana']
      this.tutor.l_name_kana = obj['l_name_kana']
      this.tutor.gender = obj['gender']
      this.tutor.birthday = obj['birthday']
      this.tutor.zip = obj['zip']
      this.watch.pref = obj['pref']
      this.tutor.address1 = obj['address1']
      this.tutor.address2 = obj['address2']
      this.tutor.tel1 = obj['tel1']
      this.tutor.tel2 = obj['tel2']
      this.tutor.mail1 = obj['mail1']
      this.tutor.mail2 = obj['mail2']
      this.tutor.home_zip = obj['home_zip']
      this.watch.home_pref = obj['home_pref']
      this.tutor.home_address1 = obj['home_address1']
      this.tutor.home_address2 = obj['home_address2']
      this.tutor.home_tel = obj['home_tel']
      this.tutor.school_name = obj['school_name']
      this.watch.school_stage = obj['school_stage']
      this.tutor.department = obj['department']
      this.watch.old_grade = obj['old_grade']
      this.tutor.grade_flag = obj['grade_flag']
      this.tutor.department_type = obj['department_type']
      this.tutor.club = obj['club']
      this.watch.transportation_car = obj['transportation_car']
      this.watch.transportation_bike = obj['transportation_bike']
      this.watch.transportation_scooters = obj['transportation_scooters']
      this.watch.transportation_bicycle = obj['transportation_bicycle']
      this.watch.transportation_train = obj['transportation_train']
      this.watch.transportation_none = obj['transportation_none']
      this.tutor.nearest_station = obj['nearest_station']
      this.tutor.high_school_name = obj['high_school_name']
      this.tutor.high_school_club = obj['high_school_club']
      this.watch.exam_s = obj['exam_s']
      this.watch.exam_c = obj['exam_c']
      this.watch.exam_k = obj['exam_k']
      this.watch.exam_d = obj['exam_d']
      this.watch.experience_tutor = obj['experience_tutor']
      this.tutor.experience_tutor_note = obj['experience_tutor_note']
      this.watch.experience_cram = obj['experience_cram']
      this.tutor.experience_cram_note = obj['experience_cram_note']
      this.watch.experience_none = obj['experience_none']
      this.watch.medium = obj['medium']
      this.tutor.medium_note = obj['medium_note']
      this.tutor.published = obj['published']
      this.tutor.information = obj['information']
      this.tutor.impression = obj['impression']
      this.watch.training = obj['training']
      this.tutor.training_note = obj['training_note']
      this.watch.ssk = obj['ssk']
      this.tutor.note = obj['note']
      // console.log(obj)
    },

    reset () {
      this.tutor.state = 1
      this.tutor.registration_date = moment().format('YYYY/MM/DD')
      this.tutor.f_name = ''
      this.tutor.l_name = ''
      this.tutor.f_name_kana = ''
      this.tutor.l_name_kana = ''
      this.tutor.gender = 0
      this.tutor.birthday = '0001/01/01'
      this.tutor.zip = ''
      this.watch.pref = 0
      this.tutor.address1 = ''
      this.tutor.address2 = ''
      this.tutor.tel1 = ''
      this.tutor.tel2 = ''
      this.tutor.mail1 = ''
      this.tutor.mail2 = ''
      this.tutor.home_zip = ''
      this.watch.home_pref = 0
      this.tutor.home_address1 = ''
      this.tutor.home_address2 = ''
      this.tutor.home_tel = ''
      this.tutor.school_name = ''
      this.watch.school_stage = 0
      this.tutor.department = ''
      this.watch.old_grade = 0
      this.tutor.grade_flag = 0
      this.tutor.department_type = 0
      this.tutor.club = ''
      this.watch.transportation_car = 0
      this.watch.transportation_bike = 0
      this.watch.transportation_scooters = 0
      this.watch.transportation_bicycle = 0
      this.watch.transportation_train = 0
      this.watch.transportation_none = 0
      this.tutor.nearest_station = ''
      this.tutor.high_school_name = ''
      this.tutor.high_school_club = ''
      this.watch.exam_s = 0
      this.watch.exam_c = 0
      this.watch.exam_k = 0
      this.watch.exam_d = 0
      this.watch.experience_tutor = 0
      this.tutor.experience_tutor_note = ''
      this.watch.experience_cram = 0
      this.tutor.experience_cram_note = ''
      this.watch.experience_none = 0
      this.watch.medium = 0
      this.tutor.medium_note = ''
      this.tutor.published = 0
      this.tutor.information = 1
      this.tutor.impression = 0
      this.watch.training = 0
      this.tutor.training_note = ''
      this.watch.ssk = 0
      this.tutor.note = ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.get()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.save()
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  overflow: scroll;
  height: calc(100vh - 265px);
}
.errors {
  color: red;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  background-color: var(--color-point);
  color: #fff;
  margin-bottom: 13px;
  font-size:1rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  padding: 1em;
  border: 0;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
  &:hover {
    opacity: .8;
  }
  &:focus {
    outline: 0;
  }
}
</style>



// WEBPACK FOOTER //
// TutorsAdd.vue?3eaf1710